//
//
//
//
export default {
  name: 'd2-input'
};